import axios from 'axios'
import _merge from 'lodash/merge'
import urljoin from 'url-join'
import Vue from 'vue'
import later from './later'

let config = {
  APP_ID: 'forepaas'
}

const setEnv = (env = 'production') => {
  const defaultValues = {
    STORE: 'https://store.forepaas.io',
    FPUI: 'https://hq.forepaas.io',
    DOCS: 'https://docs.ovhcloud.com/en/guides/public-cloud/data-platform',
    STATUS: 'https://status.forepaas.io',
    KING: 'https://hq-api.forepaas.io/iam',
    ORGANIZATION: 'https://hq-api.forepaas.io/organizations',
    QUOTA_MANAGER: 'https://hq-api.forepaas.io/quota-manager',
    BILLING: 'https://hq-api.forepaas.io/billing',
    FPAPI: 'https://hq-api.forepaas.io',
    SUPPORT: 'https://hq.forepaas.io/#/support',
    STORAGE: 'https://storage-engine.forepaas.io',
    QUOTAS: false,
    SIGNUP: false,
    TRINO_CONNECTOR: true,
    CREATE_ORGANIZATION: true,
    DATA_PLATFORM_ACCESS: false,
    MAINTENANCE_STATUS_PAGE: 'https://public-cloud.status-ovhcloud.com/',
    // OVHcloud CMP (consent management). CONSENT_ENV is separate from VUE_APP_ENV
    // because the latter is 'production' on both preprod and production builds.
    CONSENT_URL: 'https://www.status-ovhcloud.com/cmp/cmp.iife.js',
    CONSENT_ENV: 'production',
    CONSENT_REGION: 'EU',
    // Commanders Act container (Piano Analytics), injected by the CMP once analytics is
    // consented. Off unless a deploy target sets it in docker-bake.hcl, so local runs and
    // bare builds never send real hits — see src/shared/Analytics/AnalyticsClient.js.
    TRACKING_URL: '',
    // `site_name` and `environment` of the analytics data layer, per deploy target
    TRACKING_SITE_NAME: 'Data Platform',
    TRACKING_ENVIRONMENT: 'dev'
  }
  const PLATFORM = {
    local: {
      STORE: 'https://store-dev.forepaas.com',
      FPUI: 'https://hq-dev.forepaas.com',
      DOCS: 'https://docs.ovhcloud.com/en/guides/public-cloud/data-platform',
      STATUS: 'https://status.forepaas.io',
      KING: 'https://hq-dev-api.forepaas.com/iam',
      ORGANIZATION: 'https://hq-dev-api.forepaas.com/organizations',
      QUOTA_MANAGER: 'https://hq-dev-api.forepaas.com/quota-manager',
      BILLING: 'https://hq-dev-api.forepaas.com/billing',
      FPAPI: 'https://hq-dev-api.forepaas.com',
      SUPPORT: 'https://hq-dev.forepaas.com/#/support',
      STORAGE: 'https://storage-engine-dev.forepaas.com',
      QUOTAS: true,
      SIGNUP: true,
      TRINO_CONNECTOR: true,
      CREATE_ORGANIZATION: true,
      DATA_PLATFORM_ACCESS: true,
      MAINTENANCE_STATUS_PAGE: 'https://public-cloud.status-ovhcloud.com/',
      // CONSENT_URL is the same on every environment now — only the consent API
      // host differs, selected by CONSENT_ENV.
      CONSENT_ENV: 'preproduction'
    }
  }
  config = _merge(config, defaultValues)
  if (PLATFORM[env]) _merge(config, PLATFORM[env])

  config.DATAPLANT_MODE = false
  config.STORE = process.env.VUE_APP_STORE || config.STORE
  config.FPUI = process.env.VUE_APP_FPUI || config.FPUI
  config.DOCS = process.env.VUE_APP_DOCS || config.DOCS
  config.STATUS = process.env.VUE_APP_STATUS || config.STATUS
  config.KING = process.env.VUE_APP_KING || config.KING
  config.FPAPI = process.env.VUE_APP_FPAPI || config.FPAPI
  config.BILLING = process.env.VUE_APP_BILLING || config.BILLING
  config.ORGANIZATION = process.env.VUE_APP_ORGANIZATION || config.ORGANIZATION
  config.QUOTA_MANAGER = process.env.VUE_APP_QUOTA_MANAGER || config.QUOTA_MANAGER
  config.SUPPORT = process.env.VUE_APP_SUPPORT || config.SUPPORT
  config.STORAGE = process.env.VUE_APP_STORAGE || config.STORAGE
  config.QUOTAS = process.env.VUE_APP_QUOTAS === 'true' || config.QUOTAS
  config.SIGNUP = process.env.VUE_APP_SIGNUP === 'true' || config.SIGNUP
  config.TRINO_CONNECTOR = process.env.VUE_APP_TRINO_CONNECTOR === 'true' ? true : config.TRINO_CONNECTOR
  config.CREATE_ORGANIZATION = process.env.VUE_APP_CREATE_ORGANIZATION === 'false' ? false : config.CREATE_ORGANIZATION
  // DATA_PLATFORM_ACCESS to true if set to true on ENV var, else default to default value
  config.DATA_PLATFORM_ACCESS = process.env.VUE_APP_DATA_PLATFORM_ACCESS === 'true' ? true : config.DATA_PLATFORM_ACCESS
  config.MAINTENANCE_STATUS_PAGE = process.env.VUE_APP_MAINTENANCE_STATUS_PAGE || config.MAINTENANCE_STATUS_PAGE
  config.CONSENT_URL = process.env.VUE_APP_CONSENT_URL || config.CONSENT_URL
  config.CONSENT_ENV = process.env.VUE_APP_CONSENT_ENV || config.CONSENT_ENV
  config.CONSENT_REGION = process.env.VUE_APP_CONSENT_REGION || config.CONSENT_REGION
  // NOTE: not `||` like the lines above — an explicitly empty VUE_APP_TRACKING_URL is
  // meaningful (it disables tracking) and must not fall back to the container URL.
  config.TRACKING_URL = process.env.VUE_APP_TRACKING_URL !== undefined ? process.env.VUE_APP_TRACKING_URL : config.TRACKING_URL
  config.TRACKING_SITE_NAME = process.env.VUE_APP_TRACKING_SITE_NAME || config.TRACKING_SITE_NAME
  config.TRACKING_ENVIRONMENT = process.env.VUE_APP_TRACKING_ENVIRONMENT || config.TRACKING_ENVIRONMENT

  // Set all the baseURL that should be injected with an Organization_Id header when needed
  config.INJECT_ORGANIZATION_ID = [
    config.FPAPI,
    config.STORE,
    config.STORAGE
  ]

  // Display FPUI version in console
  console.info(
    `%c %cFPUI: v${process.env.VUE_APP_VERSION}`,
    "font-size: 50px; background: url('data:image/png;base64,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') no-repeat; background-size: contain;",
    'font-size: 12px;'
  )
}

setEnv(process.env.VUE_APP_ENV || 'production')

let cache = null

const setConfig = (appConfig = {}) => {
  config = _merge(config, appConfig)
  config._init = true
}

const isDataplatform = () => {
  return config.DATA_PLATFORM_ACCESS
}

// Hosts the sign-in buttons may redirect to, read synchronously: the dashboard SPA never
// calls setConfig(), so the default export would never resolve there.
const signInConfig = () => {
  return {
    FPUI: config.FPUI,
    BASE_URL: config.BASE_URL
  }
}

// Consent (OVHcloud CMP) settings, read synchronously: setEnv() has already run at module
// load, and the CMP must be configured without waiting for the async project lookup that
// the default export performs.
const consentConfig = () => {
  return {
    url: config.CONSENT_URL,
    environment: config.CONSENT_ENV,
    region: config.CONSENT_REGION
  }
}

// Commanders Act tracking settings, read synchronously for the same reason as
// consentConfig() above. `universe` comes from the module's config/global.js, merged in by
// setConfig() before the analytics start.
const trackingConfig = () => {
  return {
    url: config.TRACKING_URL,
    universe: config.TRACKING_UNIVERSE,
    siteName: config.TRACKING_SITE_NAME,
    environment: config.TRACKING_ENVIRONMENT
  }
}

const canCreateOrganization = () => {
  return config.CREATE_ORGANIZATION
}

const documentationLink = (args) => {
  return `${config.DOCS}${args}`
}

const isQuotasEnabled = () => {
  return true
  // return config.QUOTAS // force enable quotas, always
}

const canInjectOrganizationHeader = (base) => {
  if (!config.ORGANIZATION_ID || config.ORGANIZATION_ID === 'iam' || config.FORCE_HEADERS) return false
  return config.INJECT_ORGANIZATION_ID.some(b => base.startsWith(b))
}

const setProjectBaseUrl = (project) => {
  config.ORGANIZATION_ID = project.organization_id
  config.BASE_URL = `https://${project.url}`
  config.PROJECT_ID = project.id
  config.FPRN = project.fprn
  config.PROJECT_NAME = project.display_name
  config.OFFER = project.offer || 'mutualized'
  config.CLUSTER = project.cluster || project.cluster_name
  config.SERVICES = project.services || []
  config.PROJECT_FEATURE_FLAGS = project.feature_flags || {}

  config.IAM = process.env.VUE_APP_IAM || urljoin(config.BASE_URL, 'iam')
  config.DPE = process.env.VUE_APP_DPE || urljoin(config.BASE_URL, 'dpe')
  config.DWH = process.env.VUE_APP_DWH || urljoin(config.BASE_URL, 'dwh')
  config.DM = process.env.VUE_APP_DM || urljoin(config.BASE_URL, 'dwh')
  config.QB = process.env.VUE_APP_QB || urljoin(config.BASE_URL, 'qb')
  config.CC = process.env.VUE_APP_CC || urljoin(config.BASE_URL, 'control-center')
  config.ALERTING = process.env.VUE_APP_ALERTING || urljoin(config.BASE_URL, 'alerting')
  config.QUERY_ADMIN = process.env.VUE_APP_QUERY_ADMIN || urljoin(config.BASE_URL, 'query-admin')
  config.ML = process.env.VUE_APP_ML || urljoin(config.BASE_URL, 'ml')
  config.DTL = process.env.VUE_APP_DTL || urljoin(config.BASE_URL, 'datalab')
  config.DS = process.env.VUE_APP_DS || urljoin(config.BASE_URL, 'datastore')
  config.APPSERVICE = process.env.VUE_APP_APPERVICE || urljoin(config.BASE_URL, 'appservice')
  config.NOTEBOOK_MANAGER = process.env.VUE_APP_NOTEBOOK_MANAGER || urljoin(config.BASE_URL, 'notebook-manager')

  const wsUrl = (httpUrl) => {
    return httpUrl.replace('https://', 'wss://').replace('http://', 'ws://')
  }

  config.DPE_WS = `${config.DPE.replace('https://', 'wss://').replace('http://', 'ws://')}/ws`
  config.IAM_WS = `${config.IAM.replace('https://', 'wss://').replace('http://', 'ws://')}/ws`
  config.ML_WS = `${config.ML.replace('https://', 'wss://').replace('http://', 'ws://')}/ws`
  config.DWH_WS = `${config.DM.replace('https://', 'wss://').replace('http://', 'ws://')}/ws`
  config.QB_WS = `${config.QB.replace('https://', 'wss://').replace('http://', 'ws://')}/ws`

  config.EVENT_MANAGER_WS = `${wsUrl(config.BASE_URL)}/event-manager/ws`
}

const cacheProjectInfo = {}
const cacheOrganizationInfo = {}

/* istanbul ignore next */
const getConfig = async () => {
  if (!config._init) return later(10, getConfig)
  config.setEnv = setEnv

  if (!config.CMP) {
    const projectId = (window.location.hash.split('#/')[1] || '').split('/')[0].split('?')[0]
    // Use that variable to force project url when fpapi is down (dev only)
    if (process.env.VUE_APP_DATAPLANT) {
      setProjectBaseUrl({
        url: process.env.VUE_APP_DATAPLANT,
        organization_id: 'fpdevenv',
        id: 'fpdevenv',
        fprn: 'fpdevenv-lg3yw4m7',
        display_name: 'Local mode'
      })
      return config
    }
    if (projectId === 'king') {
      setProjectBaseUrl({
        url: new URL(config.KING).host,
        organization_id: 'iam',
        id: 'king',
        fprn: 'iam-king',
        display_name: 'King'
      })
      return config
    }
    cacheProjectInfo[projectId] = cacheProjectInfo[projectId] || axios.get(urljoin(config.FPAPI, `v1/projects/${projectId}/info`), {
      withCredentials: true
    })
    try {
      const projectMetadata = await cacheProjectInfo[projectId]
      setProjectBaseUrl(projectMetadata.data)
    } catch (err) {
      try {
        config.ORGANIZATION_ID = projectId
        cacheOrganizationInfo[config.ORGANIZATION_ID] = cacheOrganizationInfo[config.ORGANIZATION_ID] || axios.get(urljoin(config.ORGANIZATION, `v1/organizations/${config.ORGANIZATION_ID}/info`), {
          withCredentials: true
        })
        const projectMetadata = await cacheOrganizationInfo[config.ORGANIZATION_ID]
        setProjectBaseUrl({
          url: new URL(config.KING).host,
          organization_id: config.ORGANIZATION_ID,
          id: config.ORGANIZATION_ID,
          fprn: config.ORGANIZATION_ID,
          display_name: projectMetadata.name
        })
        config.ORGANIZATION_MODE = true
        config.FORCE_HEADERS = {
          'Organization-Id': config.ORGANIZATION_ID
        }
      } catch (error) {
        throw new Error('PROJECT_NOT_FOUND')
      }
    }
  } else {
    const projectId = Vue.$router.currentRoute.value.params?.projectId || Vue.$router.currentRoute.value.params?.dataplantId
    if (projectId) {
      cacheProjectInfo[projectId] = cacheProjectInfo[projectId] || axios.get(urljoin(config.FPAPI, `v1/projects/${projectId}/info`), {
        withCredentials: true
      })
      try {
        const projectMetadata = await cacheProjectInfo[projectId]
        setProjectBaseUrl(projectMetadata.data)
      } catch (err) {
        throw new Error('PROJECT_NOT_FOUND')
      }
    }
  }

  if (config.ORGANIZATION_ID) {
    cacheOrganizationInfo[config.ORGANIZATION_ID] = cacheOrganizationInfo[config.ORGANIZATION_ID] || axios.get(urljoin(config.ORGANIZATION, `v1/organizations/${config.ORGANIZATION_ID}/info`), {
      withCredentials: true
    })
    try {
      const organizationMetadata = await cacheOrganizationInfo[config.ORGANIZATION_ID]
      config.ORGANIZATION_NAME = organizationMetadata.data.name
      config.SUB_STATUS = organizationMetadata.data.subscription_status
      config.SUB_SCHEDULED_STATUS = organizationMetadata.data.subscription_scheduled_status
      config.ORG_FEATURE_FLAGS = organizationMetadata.data.feature_flags || {}
    } catch (err) {
      throw new Error('ORGANIZATION_NOT_FOUND')
    }
  }

  return config
}

/* istanbul ignore next */
export default async () => {
  if (Vue.$router) await Vue.$router.isReady()
  if (!cache) cache = await getConfig()
  const routeParams = Vue.$router.currentRoute.value.params
  if (routeParams.dataplantId) cache.PROJECT_ID = routeParams.dataplantId
  if (routeParams.projectId) cache.PROJECT_ID = routeParams.projectId
  if (routeParams.organizationId) cache.ORGANIZATION_ID = routeParams.organizationId
  return cache
}

export {
  setConfig,
  setProjectBaseUrl,
  canInjectOrganizationHeader,
  isDataplatform,
  canCreateOrganization,
  consentConfig,
  signInConfig,
  trackingConfig,
  documentationLink,
  isQuotasEnabled
}
